import { QueryParamConfig } from 'serialize-query-params/lib/types'
import { decodeString, encodeString } from 'use-query-params'
import {
  PredefinedDateRangeItem,
  predefinedDateRanges
} from '../../utils/predefinedDateRanges'

export const DatePeriodQueryParam: QueryParamConfig<PredefinedDateRangeItem | null> =
  {
    decode: (period): PredefinedDateRangeItem | null => {
      const parsedPeriod = decodeString(period)
      if (!parsedPeriod) {
        return null
      }

      const match = parsedPeriod.match(/^(\d+)(months|days)$/) // only accepts days currently, as unit
      if (!match) {
        return null
      }
      const [, amount, unit] = match
      const amountAsDigit = +amount
      if (!amountAsDigit || !unit) {
        return null
      }
      return (
        predefinedDateRanges.find((dateRange) => {
          return dateRange.unit == unit && dateRange.amount === amountAsDigit
        }) || null
      )
    },
    encode: (period?: null | PredefinedDateRangeItem) => {
      if (!period) {
        return undefined
      }
      return encodeString(period ? `${period.amount}${period.unit}` : undefined)
    }
  }
